import _ from 'lodash'

export const TraitScore = {
    INFERIOR: -3,
    BAD: -1,
    GOOD: 1,
    SUPERIOR: 3,
    STUPENDOUS: 6,
}

export const traitScoreColors = {
    [TraitScore.INFERIOR]: '#bb0000',
    [TraitScore.BAD]: '#B54F29',
    [TraitScore.GOOD]: '#0Ba467',
    [TraitScore.SUPERIOR]: '#5062DB',
    [TraitScore.STUPENDOUS]: '#ff8a9f',
    0: '#777',
}

export const traitsByScore = {
    [TraitScore.INFERIOR]: [
        'Always Bored',
        'Always Confused',
        'Always Forgets',
        'Always Grumpy',
        'Always Hungry',
        'Always Lonely',
        'Always Sad',
        'Always Tired',
        'Rarely Affectionate',
        'Very Calm',
    ],

    [TraitScore.BAD]: [
        'Often Bored',
        'Often Confused',
        'Often Forgets',
        'Often Grumpy',
        'Often Hungry',
        'Often Lonely',
        'Often Sad',
        'Often Tired',
        'Sometimes Affectionate',
        'Pretty Calm',
    ],

    [TraitScore.GOOD]: [
        'Sometimes Bored',
        'Sometimes Confused',
        'Sometimes Forgets',
        'Sometimes Grumpy',
        'Sometimes Hungry',
        'Sometimes Lonely',
        'Sometimes Sad',
        'Sometimes Tired',
        'Often Affectionate',
        'Pretty Excitable',
    ],

    [TraitScore.SUPERIOR]: [
        'Rarely Bored',
        'Rarely Confused',
        'Rarely Forgets',
        'Rarely Grumpy',
        'Rarely Hungry',
        'Rarely Lonely',
        'Rarely Sad',
        'Always Affectionate',
        'Very Excitable',
    ],

    [TraitScore.STUPENDOUS]: [
        'Rarely Tired',
    ],
}

export const unimplementedSuperiorTraits = ['Always Playful', 'Rarely Restless']

export const traitScores = {}
_.each(traitsByScore, (traits, score) => {
    _.each(traits, (trait) => {
        traitScores[trait] = parseInt(score)
    })
})

export const doodleScore = (doodle) => {
    // Calculate the simple score based on the doodle's traits
    let score = 0
    let hasOnlySuperiorTraits = doodle.traits.length >= 4
    _.each(doodle.traits, (trait) => {
        const traitScore = traitScores[trait] || 0
        if (traitScore < TraitScore.SUPERIOR && !unimplementedSuperiorTraits.includes(trait)) hasOnlySuperiorTraits = false
        score += traitScore
    })

    // Add an extra bonus if Rarely Tired is the first trait (or at least not the last)
    const rarelyTiredIdx = doodle.traits.indexOf('Rarely Tired')
    if (rarelyTiredIdx !== -1 && rarelyTiredIdx <= 2) {
        score += 3 - rarelyTiredIdx
    }

    // Add an additional bonus point if the doodle has only superior traits
    // This is because the doodle may have even more superior ones, but the
    // game only is telling us about the first four.
    if (hasOnlySuperiorTraits) {
        score += 1
    }

    return score
}
